<i18n>
{
    "ru": {
        "deletedMsg": "Пользователь удалил свой профиль",
        "lock_profile": "Закрытый профиль",
        "read_more_info": "Подробная информация",
        "gender_male": "Мужской",
        "gender_female": "Женский",
        "registration_caption_male": "Зарегистрирован с",
        "registration_caption_female": "Зарегистрирована с",
        "month_one": "месяц",
        "month_few": "месяца",
        "month_many": "месяцев",
        "year_short": "г.",
        "year_one": "год",
        "year_few": "года",
        "year_many": "лет",
        "visit_male": "Заходил",
        "visit_female": "Заходила",
        "today_in": "сегодня в",
        "lastday_in": "вчера в",
        "is_online": "Сейчас онлайн",
        "days_one": "день",
        "days_few": "дня",
        "days_many": "дней"
    }
}
</i18n>

<template>
    <div class="profile-about">
        <div
            v-if="isDeleted"
            class="profile-about__deleted-about">
            <!--eslint-disable-next-line-->
            <div v-html="deletedMessage"></div>
        </div>

        <div
            v-if="!isDeleted && showLockMessage"
            class="profile-about__lock-about">
            {{ $t('lock_profile') }}
        </div>

        <div
            class="profile-about__about"
            v-else-if="!isDeleted"
            :class="{'profile-about__about_opened' : aboutListOpened}">

            <div
                class="profile-about-control"
                @click="toggleAbout()">
                <span>{{ $t('read_more_info') }}</span>
                <svg-icon name="icon-chevron-down"/>
            </div>

            <slide-up-down
                :duration="300"
                :active="aboutListOpened || isDeviceDesktop">

                <ul class="profile-about-list">
                    <li v-if="get(userAboutData, 'aboutText', null)" class="profile-about-list__item">
                        <div class="profile-about-list__icon">
                            <svg-icon name="icon-profile-info"/>
                        </div>
                        <div class="profile-about-list__text">
                            {{ get(userAboutData, 'aboutText', '') }}
                        </div>
                    </li>
                    <li v-if="get(userAboutData, 'gender', null)" class="profile-about-list__item">
                        <div class="profile-about-list__icon">
                            <svg-icon :name="computedGenderIcon"/>
                        </div>
                        <div class="profile-about-list__text">
                            {{ $t('gender_' + get(userAboutData, 'gender', 'male')) }}
                        </div>
                    </li>
                    <li v-if="get(userAboutData, 'birthday', null)" class="profile-about-list__item">
                        <div class="profile-about-list__icon">
                            <svg-icon name="icon-profile-birthday"/>
                        </div>
                        <div class="profile-about-list__text">
                            {{ formattedBirthday }}
                        </div>
                    </li>
                    <li v-if="get(userAboutData, 'country.name', null)" class="profile-about-list__item">
                        <div class="profile-about-list__icon">
                            <svg-icon name="icon-profile-country"/>
                        </div>
                        <div class="profile-about-list__text">
                            {{ computedRegionName }}
                        </div>
                    </li>
                    <li v-if="regDate" class="profile-about-list__item">
                        <div class="profile-about-list__icon">
                            <svg-icon name="icon-profile-date"/>
                        </div>
                        <div class="profile-about-list__text">
                            {{ regDate }} {{ regDateDuration ? '('+regDateDuration+')' : '' }}
                        </div>
                    </li>
                    <li v-if="isStranger && get(userAboutData, 'lastOnlineAt', null)"
                        class="profile-about-list__item">
                        <div class="profile-about-list__icon">
                            <svg-icon name="icon-profile-online"/>
                        </div>
                        <div class="profile-about-list__text">
                            {{ onlineStatus }}
                        </div>
                    </li>
                </ul>

            </slide-up-down>

        </div>
    </div>
</template>

<script>
import get from 'lodash/get';
import dayjs from 'dayjs';

import { mapGetters } from 'vuex'
import SlideUpDown from 'vue-slide-up-down'

const customParseFormat = require('dayjs/plugin/customParseFormat')

require('dayjs/locale/ru');

const duration = require('dayjs/plugin/duration');

export default {
    name: "BlockProfileAbout",
    components: {
        SlideUpDown
    },
    props: {
        isDeleted: {
            type: Boolean,
            default: false
        },
        showLockMessage: {
            type: Boolean,
            default: false
        },
        isStranger: {
            type: Boolean,
            default: false
        },
        userAboutData: {
            type: Object,
            default: () => {}
        },
        deletedMessage: {
            type: String,
            default: null
        },
        deletedDate: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            aboutListOpened: false
        }
    },
    computed: {
        ...mapGetters(['isDeviceDesktop']),
        computedRegionName() {

            if(this.get(this.userAboutData, 'country.name', '') &&
                this.get(this.userAboutData, 'city.name', '')
            ) {
                return this.get(this.userAboutData, 'country.name', '')
                    + ', ' + this.get(this.userAboutData, 'city.name', '')
            }

            return this.get(this.userAboutData, 'country.name', '')
        },
        translations() {
            return {
                lastday_in: this.$t('lastday_in'),
                today_in: this.$t('today_in'),
                in: this.$t('date.in'),
            }
        },
        onlineStatus() {
            const gender = get(this.userAboutData, 'gender', 'male')
            const date = get(this.userAboutData, 'lastOnlineAt', '');
            const cDateInUnix = dayjs(date).unix();

            if(dayjs().unix() < cDateInUnix + 60 * 5) {
                return this.$t('is_online')
            }

            return this.$t('visit_' + gender) + ' ' + this.$options.filters.dateFormatted(date, this.translations)
        },
        formattedBirthday() {
            dayjs.extend(customParseFormat);

            const birthdayDate = get(this.userAboutData, 'birthday', null);
            const result = dayjs(birthdayDate, 'YYYY-DD-MM').locale(this.$i18n.locale).format('D MMMM YYYY');
            return result + ' ' + this.$t('year_short');
        },
        computedGenderIcon() {
            const gender = get(this.userAboutData, 'gender', 'male')
            if(gender === 'male') {
                return 'icon-profile-male'
            }

            return 'icon-profile-female'
        },
        regDate() {
            const gender = get(this.userAboutData, 'gender', 'male')
            const date = get(this.userAboutData, 'createdAt', '');
            const caption = this.$t('registration_caption_' + gender);

            dayjs.extend(duration)

            return caption + ' ' + dayjs(date).format('DD.MM.YYYY');
        },
        regDateDuration() {
            const date = get(this.userAboutData, 'createdAt', '');

            const daysDeclension = [
                this.$t('days_one'),
                this.$t('days_few'),
                this.$t('days_many')
            ]

            const monthsDeclension = [
                this.$t('month_one'),
                this.$t('month_few'),
                this.$t('month_many')
            ]

            const yearsDeclension = [
                this.$t('year_one'),
                this.$t('year_few'),
                this.$t('year_many')
            ];

            const regDateDuration = dayjs.duration(dayjs().diff(dayjs(date)));
            let resultString = '';

            if(regDateDuration.years()) {
                resultString = this.$options.filters.numberDeclension(regDateDuration.years(), yearsDeclension)
            }

            else if(regDateDuration.months()) {
                resultString = this.$options.filters.numberDeclension(regDateDuration.months(), monthsDeclension)
            }

            else if(regDateDuration.days()) {
                resultString = this.$options.filters.numberDeclension(regDateDuration.days(), daysDeclension)
            }

            return resultString
        },
    },
    methods: {
        get,
        toggleAbout() {
            this.aboutListOpened = !this.aboutListOpened;
        }
    }
}
</script>

<style lang="less">

.profile-about {
    @{desktop} & {
        padding-bottom: rem(5);
    }

    &__lock-about,
    &__deleted-about {
        background-color: @color-bg-gray;
        border-bottom: rem(1) solid @color-gray-white;
        border-top: rem(1) solid @color-gray-white;
        color: @color-gray-light;
        font-size: rem(14);
        font-weight: 500;
        line-height: 1.5;
        text-align: center;

        padding: rem(12) rem(20);

        @{desktop} & {
            border: rem(1) solid @color-gray-white;

            margin-top: rem(20);
        }
    }

    &__about {
        border-bottom: rem(1) solid @color-gray-white;
        border-top: rem(1) solid @color-gray-white;

        &_opened{
            .profile-about-control svg {
                transform: rotate(-180deg) translateX(-5px);
            }
        }

        @{desktop} & {
            border: none;
        }

        // &[data-opened="true"] {
        //     .profile-about-list {
        //         padding: rem(5) rem(20) rem(20);

        //         max-height: rem(375);

        //         overflow: auto;

        //         visibility: visible;
        //         opacity: 1;

        //         transition-duration: 0.2s, 0.4s, 0.3s;
        //         transition-property: max-height, visibility, opacity;
        //     }

        //     .profile-about-control svg {
        //         transition: transform 0.2s;

        //         transform: rotate(-180deg) translateX(-5px);
        //     }
        // }
    }
}

.profile-about-control {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    color: @color-gray-light;
    font-size: rem(15);
    line-height: 1.5;

    padding: rem(12) rem(20);

    svg {
        fill: @color-gray-light;

        height: rem(16);
        width: rem(16);

        transition: transform 0.2s;

        transform: translateX(rem(5));
    }

    @{desktop} & {
        display: none;
    }
}

.profile-about-list {
    list-style: none;

    margin: 0;
    padding: rem(5) rem(20) rem(20);

    // max-height: 0;

    // overflow: hidden;

    // visibility: hidden;
    // opacity: 0;

    // transition-duration: 0.2s;
    // transition-property: max-height, visibility, opacity, padding;

    @{desktop} & {
        padding: rem(22) 0;

        max-height: none;
        max-width: @widthProfileContent;

        overflow: auto;

        visibility: visible;
        opacity: 1;
    }

    &__item {
        display: flex;
        flex-flow: row nowrap;

        font-size: rem(14);
        line-height: 1.5;

        &:not(:last-of-type) {
            margin-bottom: rem(19);
        }
    }

    &__icon {
        height: 20px;
        width: 20px;

        svg {
            max-height: 100%;
            max-width: 100%;
        }
    }

    &__text {
        padding-left: 10px;

        width: calc(100% - 21px);

        transform: translateY(rem(1));
    }
}
</style>
